import { NgModule } from '@angular/core';
import { FirebaseNotificationsService } from '../../../common/src/lib/services/firebase-notifications.service';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import {
  NotificationMessagesEffects,
  NotificationMessagesFacade,
} from '@boma/supplier-portal/notifications';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as fromNotificationMessages from '../../../../supplier-portal/notifications/src/lib/+state/notification-messages/notification-messages.reducer';
import { NotificationListItemComponent } from '../../../../supplier-portal/notifications/src/lib/components/notification-messages-list/notification-list-item/notification-list-item.component';
import { NotificationMessagesListComponent } from '../../../../supplier-portal/notifications/src/lib/components/notification-messages-list/notification-messages-list.component';
import { CommonModule } from '@angular/common';
import { getApp } from '@angular/fire/app';
import { UiModule } from "@boma/ui";
import { UiElementsModule } from "@boma/ui-elements";

@NgModule({
  declarations: [
    NotificationListItemComponent,
    NotificationMessagesListComponent,
  ],
  imports: [
    provideFirestore(() => {
      return getFirestore();
    }),
    provideMessaging(() => {
      return getMessaging();
    }),
    EffectsModule.forFeature([NotificationMessagesEffects]),
    StoreModule.forFeature(
      fromNotificationMessages.notificationMessagesFeatureKey,
      fromNotificationMessages.notificationMessagesReducer
    ),
    CommonModule,
    UiElementsModule
  ],
  providers: [FirebaseNotificationsService, NotificationMessagesFacade],
  exports: [NotificationListItemComponent, NotificationMessagesListComponent],
})
export class NotificationsModule {}
